const files = require.context('./', true, /\.js$/)

let tools = {}

files.keys().forEach((key) => {
  if (key === './index.js') return
  tools = Object.assign(tools, files(key).default)
})

export default tools
